import { X, Sun, Moon, Check, Settings } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useTheme } from "units/dashboard/context/ThemeProvider";
import { useLanguage } from "units/dashboard/context/LanguageProvider";

const SettingsModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation(["client", "common"]);
  const { theme, toggleTheme } = useTheme();
  const { lang, setLang, languages } = useLanguage();

  if (!isOpen) return null;

  return (
    <div className="confirm-modal-overlay" onClick={onClose}>
      <div
        className="confirm-modal-box settings-modal-box"
        onClick={(e) => e.stopPropagation()}
      >
        {/* هدر */}
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-teal-500/15 flex items-center justify-center text-teal-600 dark:text-teal-400">
              <Settings className="w-4 h-4" />
            </div>
            <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-100">
              {t("settingsModal.title")}
            </h3>
          </div>

          <button
            type="button"
            onClick={onClose}
            aria-label={t("common:close")}
            className="w-7 h-7 flex items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 dark:hover:bg-zinc-800 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* بخش تم */}
        <div className="mb-5">
          <p className="text-xs font-semibold text-gray-500 dark:text-gray-400 mb-2.5">
            {t("settingsModal.displayMode")}
          </p>

          <div className="grid grid-cols-2 gap-2">
            <button
              type="button"
              onClick={() => theme !== "light" && toggleTheme()}
              className={`
                flex items-center justify-center gap-2 px-3 py-2.5 rounded-xl text-sm font-medium
                transition-all duration-200
                ${theme === "light"
                  ? "bg-teal-500/15 text-teal-700 dark:text-teal-300 ring-1 ring-teal-400/40"
                  : "text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-zinc-800"
                }
              `}
            >
              <Sun className="w-4 h-4" />
              {t("settingsModal.light")}
            </button>

            <button
              type="button"
              onClick={() => theme !== "dark" && toggleTheme()}
              className={`
                flex items-center justify-center gap-2 px-3 py-2.5 rounded-xl text-sm font-medium
                transition-all duration-200
                ${theme === "dark"
                  ? "bg-teal-500/15 text-teal-700 dark:text-teal-300 ring-1 ring-teal-400/40"
                  : "text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-zinc-800"
                }
              `}
            >
              <Moon className="w-4 h-4" />
              {t("settingsModal.dark")}
            </button>
          </div>
        </div>

        {/* بخش زبان */}
        <div>
          <p className="text-xs font-semibold text-gray-500 dark:text-gray-400 mb-2.5">
            {t("settingsModal.language")}
          </p>

          <div className="space-y-1.5">
            {languages.map((option) => {
              const isSelected = lang === option.code;

              return (
                <button
                  key={option.code}
                  type="button"
                  onClick={() => setLang(option.code)}
                  className={`
                    w-full flex items-center justify-between px-3 py-2.5 rounded-xl text-sm
                    transition-all duration-200
                    ${isSelected
                      ? "bg-teal-500/15 text-teal-700 dark:text-teal-300 ring-1 ring-teal-400/40 font-medium"
                      : "text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-zinc-800"
                    }
                  `}
                >
                  <span>{option.label}</span>
                  {isSelected && <Check className="w-4 h-4" />}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsModal;